import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ja from "dayjs/locale/ja";
import calender from "dayjs/plugin/calendar";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(calender);
dayjs.extend(timezone);
export const FMT_JST_JA = {
  DATE_TIME_SHORT: "YYYY年MM月DD日 HH:mm" as string,
  DATE: "YYYY年MM月DD日" as string,
} as const;

export const TZ = {
  UTC: "UTC" as string,
  JST: "Asia/Tokyo" as string,
} as const;
dayjs.tz.setDefault(TZ.JST);
function formatDate(data: any, noHM: boolean, timezone: string) {
  if (noHM) {
    return dayjs.unix(data).utc(false).locale(ja).format("YYYY年MM月DD日");
  }
  return dayjs.unix(data).tz(TZ.JST).locale(ja).format("YYYY年MM月DD日 HH:mm");
}
export function getCurrentHour() {
  return dayjs().locale("zh-cn").tz(TZ.JST).hour();
}
export function formatLocaleDate(date: string) {
  return dayjs(date).locale("zh-cn").format("YYYY年MM月DD日");
}
export function dateNowUnix() {
  return dayjs().tz(TZ.JST).locale(ja).valueOf();
}
export function dateNow() {
  return dayjs().tz(TZ.JST).locale(ja);
}
export function dateToday() {
  return dayjs().tz(TZ.JST).locale(ja).format("YYYYMMDD");
}
export function epochStoMs(date: number) {
  return dayjs(date).tz(TZ.JST).locale(ja).unix() * 1000;
}
export function diffInDays(date1: any, date2: any, showDecimals: boolean) {
  return Math.ceil(dayjs(date1).diff(date2, "day", true));
}
export function dateToUnix(date: number) {
  return dayjs(date).locale(ja).unix();
}
export function dateTimeToUnix(date: string) {
  return dayjs.tz(date, TZ.JST).valueOf();
}
export function getCalender() {
  return dayjs().tz(TZ.JST).locale(ja).calendar(dayjs("2008-01-01"));
}
export { formatDate };
